webpackJsonp([7],{

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(606)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(646),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60dcaf03",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = addNewProblem2pre;
/* harmony export (immutable) */ __webpack_exports__["a"] = addNewFhProblem;
/* unused harmony export uploadProblemImg */
/* unused harmony export deleteProblem */
/* unused harmony export getOssId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function addNewProblem2pre(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/createProblems',
    data: data,
    method: 'post'
  });
}

function addNewFhProblem(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/fhcreateProblems',
    data: data,
    method: 'post'
  });
}

function uploadProblemImg(formdata) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/uploadProblemImg',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 10000,
    data: formdata
  });
}

function deleteProblem(pguid) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/deleteProblem',
    method: 'post',
    data: pguid
  });
}

function getOssId() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/oss',
    method: 'post'
  });
}

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_problems__ = __webpack_require__(394);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      value: '',
      pInfo: {
        guid: '',
        main: '',
        problemImg: '',
        answer: '',
        rank: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['welcome'])),
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    commit: function commit() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_problems__["a" /* addNewFhProblem */])(this.pInfo).then(function (res) {
        if (res.data) {
          if (res.data.isOk === true) {
            _this.showMsg('保存新题成功。', 'info');
          } else {
            _this.showMsg('添加题目失败。', 'info');
          }
        } else {
          _this.showMsg('保存新题不成功。', 'info');
        }
      }).catch(function (err) {
        _this.showMsg('\u4FDD\u5B58\u65B0\u9898\u5931\u8D25\u3002' + err);
      });
    },
    showMsg: function showMsg(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';

      this.$notify({
        title: '烽火数学出题',
        message: msg,
        type: type
      });
    }
  }
});

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".centerdiv[data-v-60dcaf03]{height:auto;text-align:center}.labright[data-v-60dcaf03]{height:50px;line-height:40px}.labright[data-v-60dcaf03],.rowheight[data-v-60dcaf03]{text-align:right;vertical-align:middle}.textleft[data-v-60dcaf03]{text-align:left;height:30px}.lableft[data-v-60dcaf03]{text-align:left}.avatar-uploader .el-upload[data-v-60dcaf03]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-60dcaf03]:hover{border-color:#20a0ff}.avatar-uploader-icon[data-v-60dcaf03]{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center}.avatar[data-v-60dcaf03]{width:178px;height:178px;display:block}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/pages/fhCreateProblem.vue"],"names":[],"mappings":"AACA,4BACE,YAAa,AACb,iBAAmB,CACpB,AACD,2BACE,YAAa,AACb,gBAAkB,CAGnB,AACD,uDAHE,iBAAkB,AAClB,qBAAuB,CAKxB,AACD,2BACE,gBAAiB,AACjB,WAAa,CACd,AACD,0BACE,eAAiB,CAClB,AACD,6CACE,0BAA2B,AAC3B,kBAAmB,AACnB,eAAgB,AAChB,kBAAmB,AACnB,eAAiB,CAClB,AACD,mDACE,oBAAsB,CACvB,AACD,uCACE,eAAgB,AAChB,cAAe,AACf,YAAa,AACb,aAAc,AACd,kBAAmB,AACnB,iBAAmB,CACpB,AACD,yBACE,YAAa,AACb,aAAc,AACd,aAAe,CAChB","file":"fhCreateProblem.vue","sourcesContent":["\n.centerdiv[data-v-60dcaf03] {\n  height: auto;\n  text-align: center;\n}\n.labright[data-v-60dcaf03] {\n  height: 50px;\n  line-height: 40px;\n  text-align: right;\n  vertical-align: middle;\n}\n.rowheight[data-v-60dcaf03]{\n  text-align: right;\n  vertical-align: middle;\n}\n.textleft[data-v-60dcaf03] {\n  text-align: left;\n  height: 30px;\n}\n.lableft[data-v-60dcaf03] {\n  text-align: left;\n}\n.avatar-uploader .el-upload[data-v-60dcaf03] {\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n.avatar-uploader .el-upload[data-v-60dcaf03]:hover {\n  border-color: #20a0ff;\n}\n.avatar-uploader-icon[data-v-60dcaf03] {\n  font-size: 28px;\n  color: #8c939d;\n  width: 178px;\n  height: 178px;\n  line-height: 178px;\n  text-align: center;\n}\n.avatar[data-v-60dcaf03] {\n  width: 178px;\n  height: 178px;\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(579);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("2437e188", content, true);

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerdiv"
  }, [_c('h2', [_vm._v("出题")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-row', {
    staticClass: "rowheight"
  }, [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("guid")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "guid，可以是fh1之类"
    },
    model: {
      value: (_vm.pInfo.guid),
      callback: function($$v) {
        _vm.pInfo.guid = $$v
      },
      expression: "pInfo.guid"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("main")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "数学长征中题号"
    },
    model: {
      value: (_vm.pInfo.main),
      callback: function($$v) {
        _vm.pInfo.main = $$v
      },
      expression: "pInfo.main"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("problemImg")]), _vm._v(" "), _c('el-col', {
    staticClass: "xtextleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "问题图片,用辅助上传OSS中的工具上传"
    },
    model: {
      value: (_vm.pInfo.problemImg),
      callback: function($$v) {
        _vm.pInfo.problemImg = $$v
      },
      expression: "pInfo.problemImg"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("answer")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "答案只能输入"
    },
    model: {
      value: (_vm.pInfo.answer),
      callback: function($$v) {
        _vm.pInfo.answer = $$v
      },
      expression: "pInfo.answer"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("rank")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "题目难度级别"
    },
    model: {
      value: (_vm.pInfo.rank),
      callback: function($$v) {
        _vm.pInfo.rank = $$v
      },
      expression: "pInfo.rank"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.commit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.82fc79fc5313823c8307.js